export default __webpack_public_path__ + "media/408edc76d54f7ed027484283b94f440c378d0c2ba3b696bf03343b863fed6a32.svg";